import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {formatNumber, getLocallangText} from '../../swsRateCalculatorForm-init.mjs';

interface Tariff {
    title: string;
    icon: string;
    description_short: string;
    price: number;
    consumption: number;
    zipCode: number;
    activeLabel: string;
    quantity_cap: number | null;
    highlight: number;
}

@customElement('sws-tariff-card')
export class SwsTariffCard extends LitElement {

    @property({type: Object}) tariff!: Tariff;

    private _handleTariffSelected(e: Event) {
        e.preventDefault();

        this.dispatchEvent(new CustomEvent('tariff-selected', {
            detail: this.tariff,
            bubbles: true,
            composed: true
        }));
    }

    private _onMoreInformations(e: Event) {
        e.preventDefault();

        this.dispatchEvent(new CustomEvent('show-tariff-details', {
            detail: {title: this.tariff.title},
            bubbles: true,
            composed: true
        }));
    }

    createRenderRoot() {
        return this;
    }

    render() {
        const isCapExceeded = this.tariff.quantity_cap != null
            && this.tariff.quantity_cap > 0
            && this.tariff.consumption > this.tariff.quantity_cap;

        if (isCapExceeded) {
            return html`
                <div class="cap-exceeded card h-100 justify-content-center align-items-center text-center">
                    <div class="w-100 d-flex flex-column align-items-center bg-light-dark">
                        <img src="${this.tariff.icon}" alt="" width="80" height="80"/>
                        <h4 class="mb-3 mx-4">${this.tariff.title}</h4>
                    </div>
                    <div class="w-100 d-flex flex-column h-100 justify-content-between mx-auto mb-sm-4 flex-grow-1 mt-4 px-4">
                        <h3 class="font-22 fw-bold mb-3">
                            ${TYPO3?.lang?.["form.chooseTariff.card.quantityCap.heading"]}
                        </h3>
                        <p class="text-light-black font-arial mb-0">
                            ${unsafeHTML(getLocallangText("form.chooseTariff.card.quantityCap.description", [formatNumber(this.tariff.quantity_cap)]))}
                        </p>
                        <a href="${TYPO3?.lang?.["link.contact"] ?? '/kontakt'}"
                           class="btn btn-primary text-white align-self-center my-4 d-flex justify-content-center align-items-center" target="_blank">
                            ${TYPO3?.lang?.["btn.contactUs"]}
                        </a>
                        <div class="mt-auto mb-3">
                            <a href="#" class="d-block text-decoration-underline text-light-black mt-2"
                               @click="${this._onMoreInformations}"
                               aria-label="${getLocallangText("btn.moreInformations.ariaLabel", [this.tariff.title])}">
                                ${TYPO3?.lang?.["btn.moreInformations"]}
                            </a>
                        </div>
                    </div>
                </div>
            `;
        }

        const msg = getLocallangText("form.chooseTariff.chooseProduct.ariaLabel", [this.tariff.title]);

        return html`
            <div class="${this.tariff.highlight == 1 ? 'highlight' : ''} card h-100 justify-content-center align-items-center text-center">
                <div class="${this.tariff.highlight == 0 ? 'd-none' : ''} w-auto rounded-5 bg-white m-card px-3 py-0-75 font-12">${TYPO3?.lang?.["form.chooseTariff.card.highlight.headline"]}</div>
                <div class="w-100 d-flex flex-column align-items-center bg-light-dark rounded-top-1">
                    <img src="${this.tariff.icon}" alt="" width="80" height="80" class="icon-highlight"/>
                    <h4 class="mb-3 mx-4">${this.tariff.title}</h4>
                </div>
                <div class="w-100 d-flex flex-column h-100 justify-content-between mx-auto mb-sm-4 flex-grow-1 pt-4 bg-card rounded-bottom-1">
                    <p class="font-30 text-lg-36 mb-0"><strong>${formatNumber(this.tariff.price, 2)} €</strong></p>
                    <p class="font-arial mb-0">${TYPO3?.lang?.["form.chooseTariff.card.perMonth"]}</p>
                    <button @click="${this._handleTariffSelected}"
                            class="btn btn-primary text-white align-self-center my-4" id="${this.tariff.title}" aria-label="${getLocallangText("btn.chooseTariff.ariaLabel", [this.tariff.title])}">${TYPO3?.lang?.["btn.chooseTariff"]}
                    </button>
                    <div class="tariff-description text-start ms-4 me-4">
                        ${unsafeHTML(this.tariff.description_short)}
                    </div>
                    <div class="mt-auto mb-3 ${this.tariff.highlight == 1 ? 'pb-sm-3' : ''}">

                        <a href="#" class="d-block text-decoration-underline text-light-black mt-2 font"
                           @click="${this._onMoreInformations}" aria-label="${getLocallangText("btn.moreInformations.ariaLabel", [this.tariff.title])}">${TYPO3?.lang?.["btn.moreInformations"]}</a>
                    </div>
                </div>
            </div>
        `;
    }


}
